export const ja = {
    LEFT: '左に移動し、前日とする。',
    RIGHT: '右に移動します。 ',
    DOWN: '下に移動次の行います。',
    UP: '最大移動前の行います。',
    PGUP: 'PgUpに移動し、前月. ',
    PGDOWN: 'PgDown:移動しています。',
    HOME: 'ホーム:移動します。',
    END: '末に移動しました。',
    ESC: 'Esc/Today/圏内、カレンダーです。',
    TITLE: 'キーボードの指示'
};
